import { render, staticRenderFns } from "./imageMapInput.vue?vue&type=template&id=989b72ee&scoped=true&lang=pug&"
import script from "./imageMapInput.vue?vue&type=script&lang=js&"
export * from "./imageMapInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989b72ee",
  null
  
)

export default component.exports